<template>
  <div
    v-tooltip="$t('OFFER_CUSTOMISATION.DUPLICATE_OFFER_TEMPLATE')"
    @click.stop="copyTemplate"
  >
    <icon-base
      class="mt-1 text-disabled-medium hover:text-gray-500"
      :icon="IconCopy"
      height="20"
      width="20"
    />
  </div>
</template>
<script setup lang="ts">
import IconCopy from "@/components/icons/IconCopy.vue";
import { useI18n } from "vue-i18n";

import { useAuth } from "@/hooks/auth";
import offerTemplateService from "@/services/modules/offerTemplate";

import type { OfferTemplate } from "@/models/offers";

const { templateId, clientId = null } = defineProps<{
  templateId: string;
  clientId?: string | null;
}>();

const auth = useAuth();

const { t } = useI18n();

const emit = defineEmits<{
  templateCreated: [OfferTemplate];
}>();

const createTemplate = async (existingTemplate: OfferTemplate) => {
  const createdTemplate = await offerTemplateService.createTemplate({
    ...existingTemplate,
    id: "",
    client_id: auth.isLendflowUser ? null : clientId,
    name: `${existingTemplate.name} (${t("COMMON.COPY")})`,
  });
  emit("templateCreated", createdTemplate);
};

const copyTemplate = async () => {
  const offerTemplatesResponse =
    await offerTemplateService.getTemplate(templateId);
  createTemplate(offerTemplatesResponse.data);
};
</script>
